
import gql from 'graphql-tag';

// A placeholder GraphQL query used when dynamically skipping Apollo queries.
// Prevents Apollo from throwing errors due to missing 'query' fields in 
// skipped configurations.
export const NO_OP_QUERY = gql`query NoOp { _empty: String }`;
